import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

// alerts
import alert from '@drivesally/sally-ui/lib/libs/alert';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// gas api
import getGasById from '@drivesally/sally-fn/lib/gas/api/getById.api.gas';

// gas components
import GasModal from '../../components/GasModal/GasModal';
import GasPictures from '../../components/GasPictures/GasPictures';
import GasSectionRow from '../../components/GasSectionRow/GasSectionRow';
import GasSectionsGrid from '../../components/GasSectionsGrid/GasSectionsGrid';

// gas events
import showGasEvent from '../../events/showGas.event.gas';

// gas sections
import {sectionsList} from '../../sections/sections.gas';

// types
import dateTimeType from '@drivesally/sally-fw/lib/type/types/dateTime.type';

class GasContainer extends Component {
  static propTypes = {
    subscribe: PropTypes.func,
  };

  state = {
    visible: false,
    loading: false,
    gas: null,
    vehicle: null,
    sections: [],
  };

  componentDidMount() {
    this.props.subscribe(showGasEvent.subscribe(this.show));
  }

  show = async ({gasId, vehicle}) => {
    if (!gasId || !vehicle) return;
    this.setState({visible: true, loading: true, vehicle});

    try {
      const gas = await getGasById(gasId);
      if (!gas.type) {
        alert.info('Can not preview old GAS');
        this.setState({loading: false, visible: false});
        return;
      }
      const sections = sectionsList({vehicle, gas});
      this.setState({loading: false, gas, sections});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({loading: false, visible: false});
    }
  };

  hide = () => {
    const {visible, loading} = this.state;
    if (!visible || loading) return;
    this.setState({visible: false});
  };

  showLoader = () => {
    const {loading, gas, vehicle} = this.state;
    return loading || !gas || !vehicle;
  };

  render() {
    const {visible, gas, sections} = this.state;

    return (
      <GasModal
        visible={visible}
        loading={this.showLoader()}
        gas={gas}
        onClose={this.hide}
      >
        {!this.showLoader() && (
          <Fragment>
            {!!gas?.vehicle?.svid && (
              <GasSectionRow title="SVID">{gas.vehicle.svid}</GasSectionRow>
            )}
            {!!gas.checkin_date && (
              <GasSectionRow title="Check-in Date">
                {dateTimeType(gas.checkin_date).format()}
              </GasSectionRow>
            )}
            {!!gas.checkout_date && (
              <GasSectionRow title="Check-out Date">
                {dateTimeType(gas.checkout_date).format()}
              </GasSectionRow>
            )}
          </Fragment>
        )}
        {!this.showLoader() && (
          <Fragment>
            <GasSectionsGrid sections={sections} gas={gas} />
            <GasPictures sections={sections} gas={gas} />
          </Fragment>
        )}
      </GasModal>
    );
  }
}

export default subscriptionHOC(GasContainer);
